import { useRouter } from 'next/router';
import { useEffect, useState, ViewTransition } from 'react';

type ProgressState = 'idle' | 'loading' | 'complete';

export function RouteProgress() {
  const router = useRouter();
  const [state, setState] = useState<ProgressState>('idle');

  useEffect(() => {
    let completeTimer: ReturnType<typeof setTimeout>;

    const handleStart = () => {
      clearTimeout(completeTimer);
      setState('loading');
    };

    const handleComplete = () => {
      setState('complete');

      completeTimer = setTimeout(() => {
        setState('idle');
      }, 200);
    };

    const handleError = () => {
      clearTimeout(completeTimer);
      setState('idle');
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleError);

    return () => {
      clearTimeout(completeTimer);

      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleError);
    };
  }, [router]);

  if (state === 'idle') {
    return null;
  }

  return (
    <ViewTransition default="none" enter="progress-enter" exit="progress-exit">
      <div className="fixed top-0 left-0 right-0 z-9999 h-0.75 pointer-events-none">
        <div
          className={`h-full bg-blue-500 origin-left
            ${state === 'loading' ? 'animate-route-progress' : ''}
            ${state === 'complete' ? 'w-full transition-all duration-150 ease-out' : ''}`}
        />
      </div>
    </ViewTransition>
  );
}
